<template>
  <section>
    <article>
      <h2>AUTHORIZATION AND CONSENT FORM TO PARTICIPATE IN TELEMEDICINE CONSULTATION</h2>
      <p>
        The purpose of this form is to obtain your consent to participate in a telemedicine consultation with a physician/s through the use of SeriousMD-Now Serving (“SMD-NS”) platform.
      </p>

      <h3>Purpose and Benefits</h3>
      <p>
        This service enables individuals with medical concerns to be able to connect with their physician/s for their consultation, diagnosis and treatment through the use of telecommunication and the SMD-NS platform. It will allow you to receive health services from the said physicians even while staying at home.
      </p>

      <h3>Nature of Telemedicine Consultation</h3>

      <p>During the telemedicine consultation:</p>
      <p>a) Personal details of you and/or the patient’s medical history, examinations, x-rays, and tests will be collected and discussed with other health professionals through the use of interactive video, audio, and telecommunications technology, if needed.</p>
      <p>b) Physical examination of you or the patient may take place.</p>
      <p>c) Nonmedical technical personnel may be present in the telemedicine studio to aid in video transmission, if needed.</p>
      <p>Video, audio, and/or digital photo may be recorded during the telemedicine consultation visit for quality control, audit, defense of legal claims, and for other legal and valid purposes.</p>

      <h3>Medical Information and Records</h3>

      <p>By using SMD-NS, you agree to the disclosure of your personal information, which include your medical and health information, to your physician/s and his or her personnel, and their processing of your personal information to better provide the needed professional medical opinion. You also agree that SMD-NS may process your personal information for the following purposes:</p>
      <p>1) For the fulfilment of contractual services;</p>
      <p>2) For legitimate purposes, such as, but not limited to, the operation, maintenance, enhancement, and provision of all services in the SMD-NS platform;</p>
      <p>3) For administrative purposes, such as customer services and providing notices; and,</p>
      <p>4) For promotional activities, relating to products and services offered by us and third parties we work with. You may opt-out of receiving any promotional communications by sending us an e-mail at privacy@seriousmd.com.</p>
      <p>You warrant that the information you provide are current, complete and accurate.</p>
      <p>All existing laws regarding your access to medical information and copies of your medical records apply to this telemedicine consultation. No dissemination of any patient-identifiable images, records or information from this telemedicine interaction to third parties shall occur without your consent, unless authorized under existing confidentiality laws.However, aside from the purposes stated above, SMD-NS may likewise process anonymized data of personal information collected in the platform for medical research purposes and dissemination to researchers and similar entities.</p>

      <h3>Confidentiality</h3>

      <p>SMD-NS made reasonable and appropriate efforts to eliminate any confidentiality risks and protect the data/s associated with the telemedicine consultation. All existing confidentiality protections under the Data Privacy Act apply to information disclosed during this telemedicine consultation.</p>

      <h3>Risks and Consequences</h3>

      <p>The telemedicine consultation will be similar to a routine medical office visit, except interactive video technology will allow you to communicate with your physician/s at a distance. At first you may find it difficult or uncomfortable to communicate using video images. The use of video technology to deliver healthcare and educational services is a new technology and may not be equivalent to direct patient to physician contact. Following the telemedicine consultation, your physician may recommend a visit to a hospital.</p>

      <h3>Services</h3>

      <p>You understand and accept that: 1) SMD-NS platform is not intended for medical emergencies or urgent situations, and 2) SMD-NS platform should not be used as an emergency hotline for urgent medical situations. Hence, if you have an emergency, please go to your nearest hospital and seek immediate assistance from medical emergency personnel. We only provide and operate the platform that allows you to connect with your physician/s, who will conduct the telemedicine services through the Internet. We are not engaged in the practice of medicine and do not provide health care or medical services. All your health and medical care concerns should be addressed to and will be performed by your physician/s, not by SMD-NS. Your physician/s are solely responsible for the medical services to you and for the compliance with any and all requirements applicable to his or her profession.</p>

      <h3>Rights</h3>

      <p>You may withhold or withdraw consent to the telemedicine consultation at any time without affecting your right to future care or treatment, or risking the loss or withdrawal of any program benefits to which you would otherwise be entitled. You have the option to consult with your physician/s in person if you travel to his or her location.</p>

      <h3>Financial Agreement</h3>

      <p>You will be responsible for any professional fees due for the professional services rendered by your physician/s.</p>

      <h3>Patient’s Consent To The Use of Telemedicine</h3>

      <p>I have read and understood the information provided above as well as all the potential risks, consequences, and benefits of telemedicine; have discussed it with my physician/s or such assistants as may be designated, and have had the opportunity to ask questions which have been answered to my satisfaction.I hereby give my informed and unconditional consent to all terms contained in this form for the use of telemedicine in my medical care.</p>
      <p>I have read and understood the <a href="https://nowserving.seriousmd.com/terms-of-use" target="_blank">Terms and Conditions of SMD-NS</a> for the use of its platform and services, and hereby give my informed and unconditional consent to all terms contained therein.</p>
      <p>I have read and understood the <a href="https://nowserving.seriousmd.com/privacy" target="_blank">Privacy Statement of SMD-NS</a> and based thereon give my informed and unconditional consent to SMD-NS for the collection and processing of my personal information.</p>

      <div class="d-flex justify-content-center">
        <smd-btn @click="accept" type="button" class="mr-s">ACCEPT</smd-btn>
        <smd-btn @click="dontAccept" type="button">DON'T ACCEPT</smd-btn>
      </div>
    </article>
  </section>
</template>

<script>
  import {bus} from '@/main';
  import {CLOSE_TOS} from '@/constants/bus';

  export default {
    name: 'TermsAndAgreement',
    methods: {
      accept() {
        bus.$emit(CLOSE_TOS, true);
      },
      dontAccept() {
        bus.$emit(CLOSE_TOS, false);
      },
    },
  }
</script>

<style lang="scss" scoped>
  section {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: 999999;
    overflow-y: auto;
    padding: space(m);
    background-color: rgba(33, 33, 33, 0.8);
  }

  article {
    width: 100%;
    max-width: 600px;
    margin: auto;
    padding: space(l);
    border-radius: radius(medium);
    background-color: color(base, background);

    p {
      margin: space(m) 0;
      line-height: 1.5rem;
    }

    a {
      color: color(purple, tags);
      text-decoration: underline;
    }
  }
</style>
